// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XKl7","content":"styles_content__1K4ts"};